import $ from 'jquery';

export default class Readmore {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.ready();
  }

  ready() {
    this.$element.each((i, el) => {
      if (el.textContent.includes('Read more')) {
        el.remove();
      }
    });
  }
}
